<template>
  <div class='SaleCardPriceSet'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>
    <Table :TableParam="Table">
      <template v-slot:validTime="{ item }">
        <div> {{ `${item.validBegin} ~ ${item.validEnd}`}}</div>
      </template>
      <template v-slot:state="{ item }">
        <div> {{ statusMap[item.state] }}</div>
      </template>
      <template v-slot:handle="item">
        <el-link type="primary"
                 @click="()=>handleEdit(item.item)" v-if="[0,2,3].includes(item.item.state)" style="margin: 0 10px;">编辑</el-link>
                 <el-link type="danger"
                 @click="()=>handleDelete(item.item)" v-if="[0,2,3].includes(item.item.state)" style="margin: 0 10px;">删除</el-link>
                 <el-link type="primary"
                 @click="()=>invalid(item.item, 4)"  v-if="[0,2,3].includes(item.item.state)" style="margin: 0 10px;">失效</el-link>
                 <el-link type="primary"
                 @click="()=>invalid(item.item, 1)"  v-if="[0].includes(item.item.state)" style="margin: 0 10px;">提审</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
    <Dialog :show.sync="isShow"
            v-if="isShow"
            title="新建"
            @handle="confirmFun">
      <template v-slot:dialogContent>
        <el-form ref="form" :model="addForm" :rules="rules" label-width="140px">
          <el-form-item label="账户类型：" prop="cardTypeId">
            <el-select v-model="addForm.cardTypeId" placeholder="请选择账户类型" style="width: 300px">
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动购买折扣：" prop="rechargeDiscount">
            <el-input v-model="addForm.rechargeDiscount" type="number" style="width:300px;">
            </el-input>
            <span style="margin-left: 20px;">%</span>
          </el-form-item>
          <el-form-item label="基础充值金额：" prop="minRechargeAmount">
            <el-input v-model="addForm.minRechargeAmount" type="number" style="width:300px;">
            </el-input>
            <span style="margin-left: 20px;">元</span>
          </el-form-item>
          <el-form-item label="有效期："
                          prop="validTime"
                          >
              <el-date-picker v-model="addForm.validTime"
                              type="daterange"
                              range-separator="至"
                              value-format="yyyy-MM-dd"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
        </el-form>
      </template>
    </Dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import Dialog from '@/components/Dialog'
import { optionsDataReplace } from '@/utils'
import { handleCofirm } from '@/utils'

const stateProps = { label: 'text', value: 'value' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    Dialog
  },
  data () {
    // 这里存放数据
    return {
      statusMap: {
        0: '待提审',
        1: '待审核',
        2: '通过',
        3: '驳回',
        4: '失效',
      },
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Select', label: '账户类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, change: row => '', placeholder: '请选择账户类型' },
          { type: 'Select', label: '状态：', prop: 'state', options:  [
            {text:'待提审', value:0},
            {text:'待审核', value:1},
            {text:'通过', value:2},
            {text:'驳回', value:3},
            {text:'失效', value:4},], props: stateProps, change: row => '', placeholder: '请选择状态' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
        ],
      },
      typeOptions: [],
      isShow: false,
      addForm: {
        cardTypeId: '',
        rechargeDiscount: '',
        minRechargeAmount: '',
        validTime: []
      },
      rules: {
        cardTypeId: [{ required: true, message:'请选择账户类型', trigger: 'change' }],
        rechargeDiscount: [{ required: true, message:'请输入', trigger: 'blur' }],
        validTime: [{ required: true, message:'请选择有效期', trigger: 'change' }]
      },
      Table: { // 表格
        handle: true,
        paddingRight: true,
        primaryBtn: {
          show: true,
          html: '新增',
          handle: this.addFun
        },
        data: [],
        column: [
          { prop: 'cardTypeName', label: '账户类型' },
          { prop: 'rechargeDiscount', label: '活动充值折扣（%）' },
          { prop: 'minRechargeAmount', label: '基础充值金额（元）' },
          { prop: 'validTime', label: '有效期', slot: true  },
          { prop: 'state', label: '状态', slot: true },
        ]
      }
    }
  },
  created(){
    this.init()
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleDelete(item) {
      handleCofirm('确认当前操作?', 'type').then(async () => {
            this.$http.discountRuleDeleteApi(item.id)
            .then((res) => {
            if (res.status === 200) {
                this.getItemList()
                this.$message.success(res.msg || '操作成功')
            }
            }).catch((err)=>{
                this.$message.error(res.msg)
            })
        }).catch(() => { 

        })
    },
    handleEdit(item) {
      this.addForm = {
        ...item,
        state: 0
      }
      if (item.validBegin && item.validEnd) {
        this.addForm.validTime = [item.validBegin, item.validEnd]
      }
      this.isShow = true
    },
    invalid(item, state) {
      handleCofirm('确认当前操作?', 'type').then(async () => {
        let params = {
          ids: item.id,
          state
        }
            this.$http.discountRuleStateApi(params)
            .then((res) => {
            if (res.status === 200) {
                this.getItemList()
                this.$message.success(res.msg || '操作成功')
            }
            }).catch((err)=>{
                this.$message.error(res.msg)
            })
        }).catch(() => { 

        })
    },
    searchHandleForm () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getItemList()
    },
    // 新增
    addFun () {
      this.addForm = {
        cardTypeId: '',
        rechargeDiscount: '',
        minRechargeAmount: '',
        validTime: []
      }
      this.isShow = true
    },
 
    confirmFun () {
      this.$refs.form && this.$refs.form.validate(valid => {
        if(valid) {
          let params = {
            id: this.addForm.id,
            state: this.addForm.state,
            cardTypeId: this.addForm.cardTypeId,
            cardTypeName: this.typeOptions.find(item => item.id == this.addForm.cardTypeId).name,
            rechargeDiscount: this.addForm.rechargeDiscount,
            minRechargeAmount: this.addForm.minRechargeAmount,
          }
          if (this.addForm.validTime && this.addForm.validTime.length) {
            params.validBegin = this.addForm.validTime[0]
            params.validEnd = this.addForm.validTime[1]
          }
          let api = this.addForm.id ? 'discountRuleEditApi' : 'discountRuleAddApi'
          this.$http[api](params).then((res) => {
            if (res.status == 200) {
              this.$message.success(res.msg)
              this.getItemList()
              this.isShow = false
            }
          })
        }
      })
    },
    // 列表
    getItemList () {
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
       this.$http.discountRuleListApi(params).then(res => {
         if(res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list
         }
       })
    },
    // 账户类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        this.typeOptions = res.data
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
    init () {
      this.getItemList()
      this.getCardTypeList()
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.SaleCardPriceSet {
  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
}
</style>
